module.exports = __webpack_public_path__ + "img/angularjs-banner.ae972e3a.webp";